import { global } from "../constants";

export const data = {
    banner: {
        background: global.banner + "1.jpg",
        title: "Product Sourcing",
        crumb: "Product Sourcing"
    }
}